import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { doSomething } from "../../stores/ajaxActions.js";
import { isProcessing } from "../../stores/processingActions.js";
import { Localize } from "../../scripts/shared/localize.js";


const CouponBox = () => {
  const start = useRef(true);

  const [disable, setDisabled] = useState(true);

  const [error, setError] = useState(null);

  const [email, setEmail] = useState("");

  const dispatch = useDispatch();

  const _isProcessing = useSelector(state => state.isProcessing);

  useEffect(() => {
    if (start.current) {
      dispatch(isProcessing({
        key: "ajax/coupon",
        isProcessing: false
      }));

      start.current = false;
      return;
    }

    var _disable = true;

    if (email !== "") {
      setError(null);

      _disable = false;
    }

    setDisabled(_disable);
  }, [email]);

  const formValidation = () => {
    if (email === "") {
      setError(Localize.L("Inserisci un indirizzo email valido!"));

      return false;
    }

    return true;
  };

  const handleSave = () => {
    if (!formValidation()) {
      return false;
    }

    dispatch(doSomething("/ajax/coupon", { email: email, type: "newsletter" }, "POST"));

    return false;
  };

  return (
    <div className="row" style={{ width: "100%" }}>
      <div className="col-md-6 col-xs-12" style={{ padding: "10px" }}>
        <div className="pl-4 mb-3" style={{ fontWeight: 500, lineHeight: 1.1, fontSize: "30px" }}>{Localize.L("5 € di sconto di benvenuto")}</div>
        <div className="pl-4" style={{ fontSize: "14px" }}>{Localize.L("Acquista gomme online a prezzi scontati.")}</div>
      </div>
      <div className="col-md-6 col-xs-12" style={{ padding: "10px" }}>
        <form className="form-inline" role="form" onSubmit={handleSave}>
          <div className="row pl-4">
            <div className="col-md-7 col-xs-12">
              <input type="text" name="nameLabel" value={email} onChange={e => setEmail(e.target.value)} className="form-control mb-3" placeholder={Localize.L("Indirizzo email")} />
              <div style={{ color: "#737373", fontSize: "14px" }}>
                {Localize.L("Email")}
                {error ? <span className="alert alert-danger pl-5">{error}</span> : ""}
              </div>
            </div>
            <div className="col-md-5 col-xs-12 pr-lg-5">
              <button type="submit" className="btn myYellow mb-3" disabled={disable || _isProcessing.mostRecentStatus}
                style={{
                  textDecoration: "none", color: "#fff", backgroundColor: "#f89406", borderColor: "#8c8c8c", backgroundImage: "linear-gradient(to bottom,#fbb450,#f89406)",
                  backgroundRepeat: "repeat-x;box-shadow: inset 0 3px 5px rgba(0,0,0,.125)", padding: "5px 16px", fontSize: "16px", lineHeight: 1.3333333,
                  borderRadius: "3px", width: "100%", maxWidth: "150px"
                }}>
                {Localize.L("Invia sconto")}
              </button>
              <br/>
              <span style={{ color: "#737373", fontSize: "14px" }}>{Localize.L("Rispettiamo la tua privacy")}</span>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export { CouponBox };